import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  isUserLogged: boolean = false;

  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
    private keycloakSrv: KeycloakService
  ) {}

  ngOnInit(): void {
    this.setUserAuth();
  }

  setUserAuth() {
    from(this.keycloakSrv.isLoggedIn()).subscribe((auth) => {
      this.isUserLogged = auth;
    });
  }
}
